import styled from 'styled-components';
import device from '../mediaQueries';
import { fontFamilies } from '../UI/Font';

export const ModalOverflow = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000000;
  opacity: 0.8;
`;

export const ModalContent = styled.div`
  ${device.mobile`
    padding: 0;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 5px;
    bottom: 10px;
    left: 10px;
    outline: none;
    overflow: scroll;
    position: fixed;
    right: 10px;
    top: 10px;
    z-index: 100050;
`};

  ${device.desktop`
    position: fixed;
    top: 50%;
    left: 50%;
    width: 1000px;
    z-index: 1050;
    font-family: ${fontFamilies.light}
    font-size: 13px;
    overflow: auto;
    opacity: 1;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.3);
    transform: translate(-50%, -50%);
  `};
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  padding: 9px 15px;
  border-bottom: 1px solid #eee;
`;

export const ModalTitle = styled.span`
  flex: 1;
  margin: 0;
  font-size: 15px;
  line-height: 30px;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: ${fontFamilies.bold};
`;

export const CloseButton = styled.button`
  flex: 0;
  margin-top: 2px;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  font-family: ${fontFamilies.bold}
  line-height: 18px;
  color: #000000;
  text-shadow: 0 1px 0 #ffffff;
  opacity: 0.2;
`;

export const SizeGuideContent = styled.div`
  overflow-y: auto;
  max-height: 400px;
  padding: 15px;

  ${device.mobile`
    max-height: none;
  `};
`;

export const SizeNotice = styled.div`
  margin: 30px 0;
`;

export const SizeGuideTabs = styled.ul`
  & li:not(.active) a {
    color: #999;
  }
`;

export const TabLink = styled.a`
  font-family: ${fontFamilies.bold};
  font-size: 15px;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
`;

export const SizeGuideTable = styled.table`
  ${device.mobile`
    width: 100%;
  `} & tr {
    height: 34px;
    ${device.mobile`
      width: 100%;
    `};
  }

  & tbody {
    ${device.mobile`
      width: 100%;
    `};
  }

  & td:first-child,
  & th:first-child {
    padding-left: 12px;
  }

  & td:last-child,
  & th:last-child {
    padding-right: 8px;
  }

  & td,
  & th {
    padding-left: 0px;
    padding-right: 0px;
    ${device.mobile`
      padding-left: 8px;
      padding-right: 8px;
      white-space: nowrap;
    `};
  }

  & thead {
    font-family: ${fontFamilies.bold};
  }

  & tbody tr:nth-child(odd) {
    background-color: #eceeef;
  }
`;

export const HeadCell = styled.td<{ leftAligned: boolean }>`
  font-family: ${fontFamilies.bold}
  font-size: 15px;

  text-align: ${({ leftAligned }) => (leftAligned ? 'left' : 'center')};
`;

export const BodyCell = styled.td<{ leftAligned: boolean }>`
  text-align: ${({ leftAligned }) => (leftAligned ? 'left' : 'center')};
`;

export const GuideSectionTitle = styled.div`
  color: rgb(0, 0, 0);
  font-size: 15px;
  font-family: ${fontFamilies.bold}
  letter-spacing: 1px;
  text-transform: uppercase;
  user-select: none;
  padding: 0.5em 0.2em 0.5em 0px;
  margin-bottom: 1em;
`;

export const SlidePrompt = styled.div`
  color: #9b9b9b;
  text-align: right;
  font-weight: 300;
  margin-right: 0.5em;
  margin-bottom: 1em;
`;

export const GuideSection = styled.div`
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ScrollableContainer = styled.div`
  overflow-x: auto;
`;

export const ChangeDepartment = styled.div`
  align-items: center;
  color: #999999;
  display: flex;
  justify-content: center;
  text-decoration: underline;
  font-family: ${fontFamilies.light}
  font-size: 15px;
  padding: 5px 30px 0 0;
  ${device.mobile`
    padding: 0;
  `};
  cursor: pointer;
`;

export const CloseInput = styled.input`
  width: 20px !important;
  height: auto;

  &:focus {
    outline: none;
  }
`;

export const ModalHeaderBody = styled.div`
  color: #999;
  font-family: ${fontFamilies.light}
  font-size: 1em;
  padding: 3% 0;
  text-align: justify;
  user-select: none;
  line-height: 1;
`;

export const ModalHeaderTitle = styled.div`
  color: #333333;
  font-size: 15px;
  font-family: ${fontFamilies.bold}
  letter-spacing: 1px;
  text-transform: uppercase;
  user-select: none;
  display: flex;
  ${device.mobile`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 4px;
  `}
`;

export const ModalHeaderWrapper = styled.div`
  margin: 7% 5% 5% 5%;
  outline: none;
`;
